import React from 'react';
import config from '@/config.json';
import MainScreenForm from '@Components/MainScreenForm';
import MainScreenList from '@Components/MainScreenList';
import { useTranslation } from 'react-i18next';
import {
  Section,
  SectionBox,
  SectionHeadline,
  SectionCaption,
  SectionWrapper,
  SectionDescription,
} from './styled';

const DefaultTemplate = () => {
  const { t } = useTranslation();
  const brandName = config.DESCRIPTOR_NAME;
  const getCustomTextClass = (() => {
    switch (brandName) {
      case 'PROTECT247.SHOP':
      case 'PROTECT247.MOBI':
      case 'PROTECT247.LINK':
      case 'SEARQLE.SITE':
      case 'SEARQLE.CLICK':
      case 'SEARQLE.STORE':
      case 'SEARQLE.PRO':
      case 'SPOTTRACK.SHOP':
      case 'SPOTTRACK.PRO':
      case 'TOPPLAN.PRO':
      case 'MUSTREADZ.ONLINE':
      case 'MUSTREADZ.SHOP':
      case 'MUSTREADZ.CFD':
      case 'MVIEW.APP':
      case 'VR.BLLX.CC':
      case 'VNR.BLLX.CC':
      case 'VI.BLLX.CC':
      case 'VRR.BLLX.CC':
      case 'GPF.SBSCRIL.CC':
      case 'GRP.SBSCRIL.CC':
      case 'GRPT.SBSCRIL.CC':
      case 'HM.SBSCRIL.CC':
      case 'MDTN.BLLX.CC':
      case 'SPTR.BLLX.CC':
      case 'MNP.BLLX.CC':
      case 'MSPC.BLLX.CC':
      case 'LITP.BILN.CC':
      case 'EPIK.BILN.CC':
      case 'EPITK.BILN.CC':
      case 'WLR.BLLS.CC':
      case 'WOLR.BLLS.CC':
      case 'WLRY.BLLS.CC':
      case 'WOOLR.BLLS.CC':
        return 'topWhiteText';
      default:
        return '';
    }
  })();

  const isHasDescription = ['SAFEAPP.CLUB'].includes(brandName);

  return (
    <Section
      id="main"
      bgImage={`/images/main-screen/defaultTemplate/${config.TRADE_NAME.toLowerCase()}${config.DESCRIPTOR_DOMAIN.toLowerCase()}`}
    >
      <SectionWrapper>
        <SectionBox>
          <SectionCaption>
            <SectionHeadline className={getCustomTextClass}>
              {t(`mainSection.headline`)}
            </SectionHeadline>
            {isHasDescription && (
              <SectionDescription>{t(`mainSection.description`)}</SectionDescription>
            )}
            <MainScreenList />
          </SectionCaption>

          <MainScreenForm />
        </SectionBox>
      </SectionWrapper>
    </Section>
  );
};
export default DefaultTemplate;
